export const STATUS = {
  DISPONIVEL: { label: "Disponível", cls: "bg-green-500/15 text-green-400 border-green-500/40" },
  SOB_ENCOMENDA: { label: "Sob Encomenda", cls: "bg-[#FF5500]/15 text-[#FF7a33] border-[#FF5500]/40" },
  SOB_CONSULTA: { label: "Sob Consulta", cls: "bg-[#007AFF]/15 text-[#3395ff] border-[#007AFF]/40" },
  PROJETO_ESPECIAL: { label: "Projeto Especial", cls: "bg-purple-500/15 text-purple-300 border-purple-500/40" },
  EM_DESENVOLVIMENTO: { label: "Em Desenvolvimento", cls: "bg-yellow-500/15 text-yellow-300 border-yellow-500/40" },
  FUTURO: { label: "Futuro", cls: "bg-zinc-500/15 text-zinc-300 border-zinc-500/40" },
};

export const STATUS_OPTIONS = Object.keys(STATUS);

export const LEAD_STAGES = ["NOVO", "QUALIFICANDO", "DIMENSIONAMENTO", "PROPOSTA", "NEGOCIACAO", "GANHO", "PERDIDO"];
export const LEAD_STAGE_LABELS = {
  NOVO: "Novo", QUALIFICANDO: "Qualificando", DIMENSIONAMENTO: "Dimensionamento",
  PROPOSTA: "Proposta", NEGOCIACAO: "Negociação", GANHO: "Ganho", PERDIDO: "Perdido",
};

export const NAV = [
  { label: "Empresa", to: "/empresa" },
  { label: "Equipamentos", to: "/equipamentos" },
  { label: "Soluções", to: "/solucoes" },
  { label: "Dimensionamento", to: "/dimensionamento" },
  { label: "Assistência", to: "/assistencia" },
  { label: "Peças", to: "/pecas" },
  { label: "Conteúdos", to: "/conteudos" },
  { label: "Catálogos", to: "/catalogos" },
  { label: "Contato", to: "/contato" },
];

export const UF_LIST = ["SC", "PR", "RS", "SP", "MG", "RJ", "GO", "MT", "MS", "BA", "PE", "CE", "DF", "ES", "PA", "Outro"];
